<div class="room-container skeleton-border mt-4" [attr.data-testid]="'availability-skeleton-1'">
    <div class="row">
        <div class="col-12 col-md-6">
            <p-skeleton width="100%" height="100%" />
        </div>
        <div class="col-12 col-md-6">
            <div class="room-data">
                <p-skeleton height="3rem" width="80%" styleClass="mb-2" />
                <p-skeleton height="4rem" styleClass="mb-2" />

                <!-- amenities -->
                <div class="d-flex mb-3 gap-3">
                    <p-skeleton size="5rem" />
                    <p-skeleton size="5rem" />
                    <p-skeleton size="5rem" />
                </div>


                <!--rates-->
                <p-skeleton height="6rem" styleClass="mb-3" />
                <p-skeleton height="6rem" styleClass="mb-3" />
            </div>
        </div>
    </div>
</div>

